import React, { Component } from 'react';
import CardSlider from '../../components/blog-cards/CardSlider';
import CardGrid from '../../components/blog-cards/CardGrid';
import arrow from '../../assets/images/icons/arrow-left.svg';
import { api_url, headers } from '../../common/config';
import EducationalCard from './EducationalCard';

const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 2 },
    { width: 768, itemsToShow: 3 },
    { width: 1200, itemsToShow: 4 },
    { width: 1900, itemsToShow: 6 },
];

export default class Educational extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isClicked: false,
            guides: [],
        };
    }

    handleClick = () => {
        this.setState({
            isClicked: true,
        });
    };

    componentDidMount() {
        fetch(`${api_url}/autism/items/resources_page_guides?filter[status]=published`, {
            method: 'GET',
            // headers: headers,
        })
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    guides: res.data,
                });
            });
    }

    render() {
        let cards = this.props.guides.map((guide) => (
            <EducationalCard
                image={guide.image}
                title={guide.title}
                type={guide.tags[0]}
                id={guide.id}
            />
        ));

        return (
            <div className='educational_container'>
                {this.props.isGrid ? (
                    <CardGrid arrow={arrow} cards={cards} />
                ) : (
                    <>
                        <div className='title_wrapper'>
                            <h2 className='title'> أساسيات للحالات الجديدة</h2>
                            <button onClick={this.props.showAllBtn}>
                                عرض الكل
                            </button>
                        </div>
                        <CardSlider arrow={arrow} cards={cards} size={30} xsmall />
                    </>
                )}
            </div>
        );
    }
}
